import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Hyperlink } from '@offerzen/pinata-shame'

import ApplicationStatusChip from '@/CandidateExperience/components/ApplicationStatusChip'
import { ApplicationStatus } from '@/CandidateExperience/constants/applicationStatus'

import { getApplicationStatusExplanation } from './helpers'
import styles from './styles'

const AppliedContent = ({ applicationStatus, candidateSlug, interviewRequestId, companyName, children }) => {
  if (!applicationStatus) return null

  const applicationStatusExplanation = getApplicationStatusExplanation({ applicationStatus, companyName })

  return (
    <div className={styles.appliedContent}>
      <h4 className={styles.heading}>You applied for this job</h4>

      <div className={styles.statusMessageContainer}>
        <ApplicationStatusChip applicationStatus={applicationStatus} className={styles.status} />
        {applicationStatusExplanation && <p className={styles.applicationStatusExplanation}>{applicationStatusExplanation}</p>}

        {applicationStatus === ApplicationStatus.Accepted && (
          <Hyperlink
            label="View message"
            href={`/candidate/${candidateSlug}/interview_requests/${interviewRequestId}`}
            as={Link}
            className={styles.viewMessage}
          />
        )}
      </div>

      {children}
    </div>
  )
}

AppliedContent.propTypes = {
  applicationStatus: PropTypes.oneOf(Object.values(ApplicationStatus)).isRequired,
  candidateSlug: PropTypes.string.isRequired,
  interviewRequestId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  companyName: PropTypes.string,
}

export default AppliedContent
